// ----------------------------------------------------------------------
// <copyright file="Izenda.MyPreferenceTimezone.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {

  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var NumbericInput = require('share/components/controls/Izenda.NumericInput');
  var Validator = require('share/components/hoc/Izenda.Validator');
  var ValidatableNumbericInput = Validator()(NumbericInput);
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var ObservablePropTypes = require('mobx-react').propTypes;
  var actions = require('./Izenda.MyPreferenceActions');
  var MIN_OFFSET = -23;
  var MAX_OFFSET = 23;

  var MyPreferenceTimezone = function(props) {
    var currentUser = props.store.model;
    var localization = props.localization;

    return (
     <GridLayout.Row>
        <GridLayout.Col cols='2'>
          <span className='u_controlHeight control-label'>{localization.getText('USER_SETUP_LABEL_TIME_ZONE')}</span>
        </GridLayout.Col>
        <GridLayout.Col cols='10'>
          <GridLayout.Col cols='12' className='u_noPaddingAll'>
            <GridLayout.Col cols='1' className='u_noPaddingAll'>
              <span className='u_controlHeight control-label'>{localization.getText('USER_SETUP_LABEL_DATA_OFFSET')}</span>
            </GridLayout.Col>
            <GridLayout.Col cols='2' className='u_noPaddingAll'>
              <ValidatableNumbericInput className='form-control'
                                        value={currentUser.dataOffset}
                                        min={MIN_OFFSET}
                                        max={MAX_OFFSET}
                                        onChange={this.props.updateValue.bind(this.props, 'dataOffset')}/>
            </GridLayout.Col>
            <GridLayout.Col cols='1'>
              <i className='icon-ccw u_controlHeight control-label' onClick={this.props.resetDataOffset}></i>
            </GridLayout.Col>
            <GridLayout.Col cols='2'>
              <span className='u_controlHeight control-label'>{localization.getText('USER_SETUP_LABEL_TIMESTAMP_OFFSET')}</span>
            </GridLayout.Col>
            <GridLayout.Col cols='2 u_noPaddingAll'>
              <ValidatableNumbericInput className='form-control'
                                        value={currentUser.timestampOffset}
                                        min={MIN_OFFSET}
                                        max={MAX_OFFSET}
                                        onChange={this.props.updateValue.bind(this.props, 'timestampOffset')} />
            </GridLayout.Col>
            <GridLayout.Col cols='1'>
              <i className='icon-ccw u_controlHeight control-label' onClick={this.props.resetTimestampOffset}></i>
            </GridLayout.Col>
          </GridLayout.Col>
        </GridLayout.Col>
      </GridLayout.Row>
    );
  };

  MyPreferenceTimezone.propTypes = {
    store: ObservablePropTypes.observableObject.isRequired
  };

  module.exports = connect(actions)(MyPreferenceTimezone);
})();


// WEBPACK FOOTER //
// ./ui/modules/MyProfile/MyPreference/Izenda.MyPreferenceTimezone.jsx